module.exports = __webpack_public_path__ + "static/media/noah.33576b5e.jpg";